import React, {ReactElement} from 'react';
import MComponent from '../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../Toolkit/Components/Controls/Table';
import NSwagAdapter from '../Toolkit/Api/NSwagAdapter';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';
import TrafficManagementAccessTokenProvider from '../Api/TrafficManagementAccessTokenProvider';
import {IMsalContext} from '@azure/msal-react';
import {JobData, JobDataMultiReply} from '../Api/ControllerTypes/JobAssignmentTypes';
import {JobAssignmentClient} from '../Api/JobAssignmentClient';

type JobAssignmentRow = {
    data: JobData;
}

type Props = {
    parentId: number;
    msalContext: IMsalContext;
}

/** */
type State = {
    filters: MTableFilters;
    rowData: JobAssignmentRow[];
    selectedRow?: JobAssignmentRow;
}

class CrewJobsControl extends MComponent<Props, State> {

    private readonly m_jobClient: NSwagAdapter<JobAssignmentClient>;

    public constructor(props: Props) {
        super(props);

        this.m_jobClient = new NSwagAdapter<JobAssignmentClient>(new JobAssignmentClient(
            new MNSwagClientConfiguration(process.env.REACT_APP_TRAFFICMANAGEMENT_API_KEY!,
                new TrafficManagementAccessTokenProvider(this.props.msalContext))));

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.selectCrew_Click = this.selectCrew_Click.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
        this.isNoRowSelected = this.isNoRowSelected.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {},
            rowData: [],
            selectedRow: undefined
        };
    }

    async componentDidMount() {
        await this.loadPageData();
    }

    private isNoRowSelected(): boolean {
        return this.state.selectedRow === undefined;
    }

    private async selectCrew_Click(): Promise<void> {
        //this.props.navigate(`/crews/create?startDate=${this.props.startDate}&endDate=${this.props.endDate}`);
    }

    private table_onSelectionChange(selection: JobAssignmentRow | JobAssignmentRow[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as JobAssignmentRow | undefined);

    }

    private async loadPageData(): Promise<void> {
        //Read contact data.
        const contactResult = await this.m_jobClient.callWithReply(
            JobDataMultiReply, (client) => client.getAll(undefined, this.props.parentId, undefined));
        contactResult.throwIfFailed();

        this.safeSetState(draft => draft.rowData = contactResult.reply!.jobAssignments.map(n => ({data: n})));
    }

    private dateTemplate(rowData: JobAssignmentRow): string | undefined {
        if(rowData.data.jobAssignment.assignedDate !== null) {
            try {
                return rowData.data.jobAssignment.assignedDate.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    public render(): ReactElement {
        return (
            <React.Fragment>
                {/*<MToolbar>
                    <MButton label="Select Crew"
                             color="primary"
                             icon={'pi pi-users'}
                             disabled={this.isNoRowSelected}
                             onClick={this.selectCrew_Click}/>
                </MToolbar>*/}
                <MTable
                    rowKey="data.jobAssignment.id"
                    rowData={this.state.rowData}
                    filters={this.state.filters}
                    onSelectionChange={this.table_onSelectionChange}
                    sortField={'data.jobAssignment.assignedDate'}
                    sortOrder={-1}
                >
                    <Column field="data.jobAssigment.assignedDate"
                            header="Date"
                            body={this.dateTemplate}
                            dataType="date"
                            filter={false}
                            sortable={false}
                            style={{width: '20%'}}/>
                    <Column field="data.request.estimate"
                            header="Estimate"
                            filter={false}
                            sortable={false}
                            style={{width: '80%'}}/>
                </MTable>
            </React.Fragment>
        );
    }
}

export default CrewJobsControl;